export default "__VITE_ASSET__CH00qi6b__"